import * as ActionTypes from './ActionTypes';
import initialState from './InitialState';
import IFeatureState from '../../store/IFeatureState';
import { assign } from '../../shared/Assign';

export default function planEditorsReducer(
    state: any = initialState.legalEntities,
    action: { type: string; result: any }
): any {
    switch (action.type) {
        case ActionTypes.CREATE_LEGAL_ENTITY_SUCCESS: {
            const newState = assign({}, state);
            newState.list = [...state.list, assign({}, action.result)];
            return newState;
        }

        case ActionTypes.LIST_LEGAL_ENTITY_SUCCESS: {
            const newState = assign({}, state);
            newState.list = action.result;
            return newState;
        }

        case ActionTypes.NEW_LEGAL_ENTITY_SUCCESS: {
            const newState = assign({}, state);
            newState.availableCountries = assign([], action.result.availableCountries);
            return newState;
        }

        case ActionTypes.EDIT_LEGAL_ENTITY_SUCCESS: {
            const newState = assign({}, state);
            newState.edit = assign({}, action.result.legalEntity);
            newState.availableCountries = assign([], action.result.availableCountries);
            return newState;
        }

        case ActionTypes.UPDATE_LEGAL_ENTITY_SUCCESS: {
            const newState = assign({}, state);
            newState.list = [
                ...state.list.filter((x: any) => x.id !== action.result.id),
                assign({}, action.result)
            ];
            return newState;
        }

        case ActionTypes.DELETE_LEGAL_ENTITY_SUCCESS: {
            const newState = assign({}, state);
            newState.list = [...newState.list.filter((x: any) => x.id !== action.result)];
            return newState;
        }

        default:
            return state;
    }
}
